"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M13.709 4.292c-.217-.09-.457-.032-.643.153L8.614 8.897a.273.273 0 0 1-.076.036H5.18a.72.72 0 0 0-.72.719v4.318a.72.72 0 0 0 .72.719l3.349-.001a.266.266 0 0 1 .079.03l4.458 4.459a.618.618 0 0 0 .436.194c.069 0 .14-.014.207-.041.217-.09.346-.301.346-.563V4.854c0-.262-.129-.472-.346-.562Zm3.146 4.87a4.292 4.292 0 0 1 1.264 3.054 4.29 4.29 0 0 1-1.264 3.052.48.48 0 1 1-.68-.678 3.333 3.333 0 0 0 .985-2.374c0-.898-.35-1.741-.985-2.375a.481.481 0 0 1 .68-.68Zm4.15 3.045c0-1.92-.75-3.729-2.108-5.088a.48.48 0 0 0-.679.678 6.196 6.196 0 0 1 1.827 4.41 6.198 6.198 0 0 1-1.827 4.411.479.479 0 1 0 .68.677 7.15 7.15 0 0 0 2.106-5.088Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};